/* The Mom Store — Store Locator behaviour.
   City chip carousel (with dots) + filter cards by city
   + per-city illustration swap + single-result full-width column.
*/
(function () {
  var sections = document.querySelectorAll('.tms-stores');

  sections.forEach(function (root) {
    var slider = root.querySelector('[data-city-slider]');
    var dotsWrap = root.querySelector('[data-city-dots]');
    var chips = root.querySelectorAll('.tms-city-chip[data-city]');
    var grid = root.querySelector('[data-store-grid]');
    var emptyMsg = root.querySelector('[data-store-empty]');
    var cards = root.querySelectorAll('.tms-store-card[data-city]');
    var images = root.querySelectorAll('[data-city-image-group] .tms-stores__image[data-city]');

    if (!chips.length) return;

    /* ---------- Filtering ---------- */
    function setActiveCity(city) {
      chips.forEach(function (chip) {
        var active = chip.dataset.city === city;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active);
      });

      var visibleCount = 0;
      cards.forEach(function (card) {
        var match = card.dataset.city === city;
        card.classList.toggle('is-hidden', !match);
        if (match) visibleCount++;
      });

      if (grid) {
        grid.classList.toggle('tms-stores__grid--single', visibleCount === 1);
      }

      if (emptyMsg) {
        emptyMsg.hidden = visibleCount !== 0;
      }

      images.forEach(function (img) {
        var match = img.dataset.city === city;
        img.classList.toggle('is-active', match);
        img.hidden = !match;
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setActiveCity(chip.dataset.city);
        chip.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    /* Initialise with whichever chip already has is-active (first city), else first chip */
    var initialChip = root.querySelector('.tms-city-chip.is-active') || chips[0];
    setActiveCity(initialChip.dataset.city);

    /* ---------- Carousel dots ---------- */
    if (!slider || !dotsWrap) return;

    var dots = [];
    var maxScroll = 0;

    function buildDots() {
      dotsWrap.innerHTML = '';
      dots = [];

      var clientWidth = slider.clientWidth;
      var scrollWidth = slider.scrollWidth;
      maxScroll = Math.max(0, scrollWidth - clientWidth);

      var pages = Math.max(1, Math.ceil(scrollWidth / clientWidth));
      if (pages <= 1) return;

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Show more cities');
        (function (index) {
          dot.addEventListener('click', function () {
            var target = maxScroll <= 0 ? 0 : (index / (pages - 1)) * maxScroll;
            slider.scrollTo({ left: target, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }

      updateActiveDot();
    }

    function updateActiveDot() {
      if (!dots.length) return;

      var index;
      if (maxScroll <= 0) {
        index = 0;
      } else {
        // Proportional position along max scroll distance — avoids drift
        // from fixed pageWidth banding, which was misaligning on mobile.
        var ratio = slider.scrollLeft / maxScroll;
        index = Math.round(ratio * (dots.length - 1));
      }

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    var scrollTimer;
    slider.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateActiveDot, 60);
      },
      { passive: true }
    );

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 150);
    });

    buildDots();
  });
})();